const formatCash = ({ amount, amountCash, diffMethods }) => ({
  paymentForm: 'CASH',
  reservation: '',
  amount: diffMethods ? Number(amountCash) : Number(amount),
});

export default formatCash;
